import { apiClient } from '../../../api/client'
import type { MeResponse } from '../../../auth/useCurrentUser'
import type { PersonaKind } from '../personaLabel'

const BASE = '/proxy-personas'

/**
 * Sayfalama gerekmeyen bir lookup için "tümünü getir" boyutu. Uç anayasa gereği yine PagedModel
 * döner; kullanıcı başına birkaç vekalet olduğundan tek tur yeterlidir.
 */
const ALL = 200

/** Bir vekaletin persona satırı (`contracts/proxy-personas-api.md` §1). */
export interface ProxyPersona {
  userId: number
  displayName: string
  grantDate: string
  /** `false` → seçim kutusunda listelenmez; yalnız "neden yok?" ipucunda sayılır. */
  selectable: boolean
  /** `selectable === false` ise neden; bugün tek değer `MISSING_EMPLOYEE_ID`. */
  unavailableReason: string | null
  /**
   * İlişkinin türü (126). `PROXY` vekalet; asistanlıkta yetki seviyesi de buradan okunur.
   *
   * Sunucu bu alanı **ekledi**, mevcut alanlar değişmedi. Bilinmeyen bir değer gelirse (ileride
   * üçüncü bir seviye) arayüz onu vekalet gibi, yani eksiz gösterir — sessiz bir etiket yerine
   * eksik etiket tercih edilir.
   */
  kind: PersonaKind
}

interface PagedPersonas {
  content: ProxyPersona[]
}

/** TanStack Query anahtarları — tek yerde, geçersiz kılma noktalarının aynı anahtarı kullanması için. */
export const proxyPersonaKeys = {
  list: ['proxy-personas'] as const,
}

/**
 * Kullanıcının vekili olduğu kişiler.
 *
 * Liste her zaman **giriş yapan gerçek kullanıcının** vekaletlerinden hesaplanır — vekil modunda
 * çağrılsa bile değişmez (zincirleme vekalet yok).
 */
export async function getProxyPersonas(): Promise<ProxyPersona[]> {
  const { data } = await apiClient.get<PagedPersonas>(BASE, { params: { page: 0, size: ALL } })
  return data.content
}

/**
 * Personaya geçiş. Yanıt `/me` şemasındadır (hedefin etkin kimliği) — çağıran onu doğrudan `me`
 * önbelleğine yazabilir, ek bir tur gerekmez.
 */
export async function activateProxyPersona(userId: number): Promise<MeResponse> {
  const { data } = await apiClient.post<MeResponse>(`${BASE}/active`, { userId })
  return data
}

/** Kendi kimliğine dönüş; persona zaten aktif değilse de başarılıdır (idempotent). */
export async function deactivateProxyPersona(): Promise<MeResponse> {
  const { data } = await apiClient.delete<MeResponse>(`${BASE}/active`)
  return data
}
